// eslint-disable-next-line no-restricted-imports
import { matchPath, generatePath as rrGeneratePath } from 'react-router-dom';

export function generatePath(...args: Parameters<typeof rrGeneratePath>): Lowercase<string> {
  return rrGeneratePath(...args).toLowerCase() as Lowercase<string>;
}

export { matchPath, rrGeneratePath as caseSensitiveGeneratePath };
